// src/AssetManager/PreviewLightbox.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function PreviewLightbox({
  open,
  onClose,
  url,
  alt = "",
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: {
          bgcolor: "rgba(0,0,0,0.92)",
        },
      }}
    >
      {/* Close button */}
      <Box
        sx={{
          position: "fixed",
          top: 8,
          right: 8,
          zIndex: 1,
        }}
      >
        <Tooltip title="Close">
          <IconButton
            onClick={onClose}
            sx={{
              color: "#fff",
              bgcolor: "rgba(255,255,255,0.14)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.22)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <DialogContent
        sx={{
          p: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!url ? (
          <CircularProgress sx={{ color: "#fff" }} />
        ) : (
          <Box
            component="img"
            src={url}
            alt={alt}
            sx={{
              maxWidth: "98vw",
              maxHeight: "96vh",
              objectFit: "contain",
              userSelect: "none",
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

PreviewLightbox.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string,
  alt: PropTypes.string,
};
